import { Link } from "react-router-dom";
import { useSeo } from "../../hooks/useSeo";
import { articles } from "../../mocks/chigua";

const principles = [
  {
    icon: "ri-eye-line",
    title: "先核实，后呈现",
    desc: "对来自不同渠道的同一话题进行交叉比对，标注清楚哪些是已证实信息、哪些仍属传闻待证，不让误导性内容借吃瓜之名扩散。",
  },
  {
    icon: "ri-database-2-line",
    title: "聚合而非站队",
    desc: "我们提供的是「吃瓜合集」式的信息收拢与事件脉络梳理，把立场交给读者，把情绪降到最低，保持客观中立的资讯底色。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "对事不对人",
    desc: "讨论聚焦事件本身，不引导对当事人的网暴与人身攻击，倡导理性、克制、有分寸的表达氛围。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重合法权益",
    desc: "若内容涉及误解或权益问题，第一时间配合核实与处理，通过透明渠道给当事人以回应渠道。",
  },
];

const voices = [
  {
    name: "小杨 · 通勤吃瓜党",
    text: "每天早晚挤地铁全靠「今天吃瓜」的快览，几分钟就能把今天的热瓜扫个遍，最难得的是语气不阴阳怪气，看着很舒服。",
    tag: "通勤快览",
  },
  {
    name: "阿圆 · 追更常客",
    text: "关注到一些反转再反转的瓜，这里会一直跟到后续，不会发完就消失，这种「有始有终」的整理很加分。",
    tag: "追更体验",
  },
  {
    name: "老沈 · 普通读者",
    text: "最喜欢的是每次结尾那句「理性吃瓜提示」，会提醒大家别急着站队，现在愿意劝人冷静的资讯站不多了。",
    tag: "理性氛围",
  },
];

export default function About() {
  useSeo({
    title: "关于今天吃瓜｜吃瓜爆料网站的品牌介绍与内容原则",
    description:
      "了解「今天吃瓜」：我们是一家聚合全网娱乐八卦与社会热点吃瓜爆料的资讯站，坚持先核实后呈现、聚合而不站队的编辑原则，为吃瓜群众提供今日爆料合集与最新瓜速览。",
    keywords: "关于今天吃瓜,今天吃瓜介绍,吃瓜网站,内容原则",
    path: "/about",
    schemas: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于今天吃瓜",
        url: "https://fish3.cn/about",
        inLanguage: "zh-CN",
        about: { "@type": "Organization", name: "今天吃瓜" },
      },
    ],
  });

  return (
    <div className="bg-background-50">
      {/* hero */}
      <section className="relative overflow-hidden border-b border-background-200">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500" aria-hidden="true" />
        <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-background-50/10 blur-2xl" aria-hidden="true" />
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-20">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-background-50 text-2xl font-black text-primary-600">
            瓜
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black text-background-50 md:text-5xl">关于「今天吃瓜」</h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/90">
            我们相信，吃瓜是生活里热气腾腾的一部分，但吃瓜也该有理有据、有分寸。
            于是就有了今天吃瓜——一个把散落各处的今日爆料与瓜料收拢起来，整理成清爽合集的地方。
          </p>
        </div>
      </section>

      {/* intro */}
      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-14 md:px-6 lg:grid-cols-[1.3fr_1fr]">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <i className="ri-focus-3-line" aria-hidden="true" /> 品牌介绍
          </p>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950">一个怎样的吃瓜网站？</h2>
          <div className="mt-5 space-y-4 text-[15px] leading-8 text-foreground-700">
            <p>
              作为聚合型的吃瓜爆料站点，我们把目光集中在两个问题上：<strong className="text-foreground-900">今天有什么新瓜？</strong>
              以及<strong className="text-foreground-900">这些爆料目前发酵到哪一步了？</strong>
              从娱乐八卦的明星动态，到社会热点的城市百态，再到网络热议与行业内幕，我们把各平台零散的信息碎片，整理成便于快速浏览与持续追更的「吃瓜合集」。
            </p>
            <p>
              这里不追求制造焦虑，也不贩卖对立。我们更愿意做一个安静的整理者：把来龙去脉讲清楚，把不同声音摆出来，
              至于结论，交给你自己判断。理性吃瓜，先看后议，是我们始终想传递的态度。
            </p>
          </div>
          <div className="mt-6 grid grid-cols-3 gap-4">
            {[
              { num: "12+", label: "每日更瓜主题" },
              { num: "4", label: "常设吃瓜频道" },
              { num: "持续", label: "热点事件追踪" },
            ].map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                <p className="font-heading text-2xl font-black text-primary-600">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col justify-center">
          <div className="rounded-2xl bg-secondary-100 p-6 text-secondary-900">
            <i className="ri-double-quotes-l text-3xl opacity-60" aria-hidden="true" />
            <p className="mt-3 text-lg font-semibold leading-relaxed">把今天的热闹讲清楚，把理性的声音留下来。</p>
            <p className="mt-3 text-sm text-secondary-800">—— 今天吃瓜的内容信条</p>
          </div>
        </div>
      </section>

      {/* principles */}
      <section className="border-y border-background-200 bg-background-100/60">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
          <div className="text-center">
            <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-file-shield-2-line" aria-hidden="true" /> 内容原则
            </p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950">我们坚持的四件事</h2>
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2">
            {principles.map((p, i) => (
              <div key={p.title} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-6">
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-xl ${
                  i % 2 === 0 ? "bg-primary-500 text-background-50" : "bg-accent-500 text-background-50"
                }`}>
                  <i className={p.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* voices */}
      <section className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        <div className="mb-8 text-center">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <i className="ri-chat-heart-line" aria-hidden="true" /> 读者口碑
          </p>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950">吃瓜群众怎么说</h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3">
          {voices.map((v) => (
            <figure key={v.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6">
              <div className="flex gap-0.5 text-accent-500" aria-label="五颗星好评">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">“{v.text}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-bold text-secondary-900">
                  {v.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{v.name}</p>
                  <p className="text-xs text-foreground-500">{v.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* latest teaser + contact */}
      <section className="border-t border-background-200 bg-background-100/60">
        <div className="mx-auto grid max-w-6xl gap-8 px-4 py-14 md:px-6 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-flashlight-fill" aria-hidden="true" /> 我们在持续更瓜
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950">先从今天这份合集开始吧</h2>
            <div className="mt-5 flex flex-col gap-3">
              {articles.slice(0, 3).map((a) => (
                <Link key={a.id} to={`/baoliao/${a.id}`} className="group rounded-xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200">
                  <span className="text-[11px] font-medium text-primary-600">{channelLabel(a.channel)} · {a.time}</span>
                  <p className="mt-1.5 text-sm font-semibold text-foreground-900 group-hover:text-primary-700">{a.title}</p>
                </Link>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center rounded-2xl bg-primary-950 p-8 text-primary-50">
            <h2 className="font-heading text-2xl font-black text-background-50">想投稿或聊聊？</h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-100/85">无论是手上有新鲜瓜料想报料，还是对内容有疑问与建议，欢迎随时通过「联系我们」与我们沟通。</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-accent-400">
                联系我们
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
              <Link to="/baoliao" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-100/30 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-background-50/10">
                去看看瓜
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function channelLabel(key: string) {
  const map: Record<string, string> = { yule: "娱乐八卦", shehui: "社会热点", wangluo: "网络热议", hangye: "行业内幕" };
  return map[key] ?? "吃瓜资讯";
}